/** Shared Operate-dashboard layout tokens (Health, Portfolio, Performance, Journals). */

/**
 * Cap content width on large displays. 1400 keeps tables usable without
 * stretching cards / metric grids edge-to-edge on ultrawide monitors.
 */
export const DASHBOARD_CONTENT_MAX_WIDTH = 1400;

/** Desktop page padding — keep Health / Portfolio / Performance / Journals aligned. */
export const DASHBOARD_CONTENT_PADDING = '36px 72px 56px';
export const DASHBOARD_CONTENT_PADDING_MOBILE = '16px 16px 40px';

export const DASHBOARD_CARD_RADIUS = 12;
export const DASHBOARD_CARD_RADIUS_SM = 10;

/** Uppercase section labels (Open Positions, Account Metrics, Violations & Patterns, …). */
export const DASHBOARD_SECTION_TITLE_STYLE = {
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  margin: 0,
};

export function getDashboardPageShellStyle({ isMobile = false, colors } = {}) {
  return {
    padding: isMobile ? DASHBOARD_CONTENT_PADDING_MOBILE : DASHBOARD_CONTENT_PADDING,
    maxWidth: isMobile ? '100%' : DASHBOARD_CONTENT_MAX_WIDTH,
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    ...(colors?.bgPrimary ? { backgroundColor: 'transparent' } : null),
  };
}

export function getDashboardCardStyle(colors, { radius = DASHBOARD_CARD_RADIUS } = {}) {
  return {
    backgroundColor: colors.bgCard,
    border: `1px solid ${colors.border}`,
    borderRadius: radius,
  };
}
